import { Tab } from '@mui/material'
import { HeaderStyledTabs } from 'components/Shared/Tabs/HeaderStyledTabs'
import { Link } from 'react-router-dom'
export const LocationSweepstakesDetailsTabs = ({
  currentTab,
  sweepstakeId,
}: {
  currentTab: any
  sweepstakeId: number
}) => {
  return (
    <HeaderStyledTabs currentTab={currentTab}>
      <Tab
        label="Overview"
        value={`/LocationSweepstakes/${sweepstakeId}/Overview`}
        to={`/LocationSweepstakes/${sweepstakeId}/Overview`}
        component={Link}
      />
      <Tab
        label="My Participating Locations"
        value={`/LocationSweepstakes/${sweepstakeId}/ParticipatingLocations`}
        to={`/LocationSweepstakes/${sweepstakeId}/ParticipatingLocations`}
        component={Link}
      />
      <Tab
        label="Winners"
        value={`/LocationSweepstakes/${sweepstakeId}/Winners`}
        to={`/LocationSweepstakes/${sweepstakeId}/Winners`}
        component={Link}
      />
      <Tab
        label="Settings"
        value={`/LocationSweepstakes/${sweepstakeId}/Settings`}
        to={`/LocationSweepstakes/${sweepstakeId}/Settings`}
        component={Link}
      />
    </HeaderStyledTabs>
  )
}
